/** Tech stack row — Simple Icons CDN slugs (https://simpleicons.org) */
export const TECH_STACK_ITEMS = [
  { name: "React", slug: "react" },
  { name: "JavaScript", slug: "javascript" },
  { name: "TypeScript", slug: "typescript" },
  { name: "FastAPI", slug: "fastapi" },
  { name: "Python", slug: "python" },
  { name: "PostgreSQL", slug: "postgresql" },
  { name: "MongoDB", slug: "mongodb" },
  { name: "Docker", slug: "docker" },
  { name: "AWS", slug: "amazonwebservices", localIcon: true },
  { name: "Tailwind CSS", slug: "tailwindcss" },
  { name: "Framer Motion", slug: "framer" },
  { name: "Three.js", slug: "threedotjs" },
  { name: "Node.js", slug: "nodedotjs" },
];

export const TECH_STACK_ICON_COLOR = "0A2540";
export const TECH_STACK_ICON_COLOR_ON_DARK = "FFFFFF";

export function techStackIconUrl(slug, color = TECH_STACK_ICON_COLOR) {
  return `https://cdn.simpleicons.org/${slug}/${color}`;
}

export function resolveTechStackIconSrc(item, color = TECH_STACK_ICON_COLOR) {
  if (item.localIcon) {
    const variant = color === TECH_STACK_ICON_COLOR_ON_DARK ? "FFFFFF" : "0A2540";
    return `/icons/aws-${variant}.svg`;
  }
  return techStackIconUrl(item.slug, color);
}
